<template>
    <div class="mb-3" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <multiselect
            v-model="usersSelected"
            :options="users"
            :multiple="true"
            :close-on-select="false"
            :preserve-search="true"
            :placeholder="placeholder"
            label="name"
            track-by="id"
            :hide-selected="true"
            select-label=""
            selected-label=""
            deselect-label=""
            @search-change="searchUser"
        >
            <template v-slot:noResult>
                <span>Aucun résultat.</span>
            </template>
            <template v-slot:noOptions>
                <span>Écrivez pour rechercher un utilisateur...</span>
            </template>
            <!-- Croix pour tout désélectionner -->
            <template #clear>
                <span class="multiselect__clear" role="button" v-if="usersSelected && usersSelected.length" title="Effacer" aria-label="Effacer" @mousedown.prevent.stop="usersSelected = []"></span>
            </template>
        </multiselect>
        <span class="invalid-feedback text-danger d-block" v-if="hasError" v-html="errorMessage()"></span>
        <span class="form-text text-muted" v-if="informationContent !== null">
            {{ informationContent }}
        </span>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: "FormSelectSearchUsers",
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        labelHidden: {
            type: Boolean,
            required: false,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        informationContent: {
            type: String,
            required: false,
            default: null
        },
        usersPreSelected: {
            type: Array,
            required: false,
            default: () => []
        },
        errors: {
            required: true
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        },
        roles: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            usersSelected: [],
            users: [],
            loading: false,
        }
    },
    methods: {
        searchUser: _.debounce(function (query) {
            if (query.length < 3) {
                return;
            }
            this.loading = true;
            const params = { query: query };
            if (this.roles) {
                params.roles = this.roles;
            }
            axios.get('/api/search/users', { params })
                .then(response => {
                    this.users = response.data.data.map(user => ({
                        id: user.data.id,
                        name: `${user.data.first_name} ${user.data.last_name}`
                    }));
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }, 250),
        clearErrors: function () {
            if (this.hasError) {
                this.errors[this.name] = null;
            }
        },
        errorMessage: function () {
            if (this.hasError) {
                return this.errors[this.name][0];
            }
        }
    },
    computed: {
        hasError() {
            return (
                this.errors &&
                this.errors[this.name] &&
                this.errors[this.name].length > 0
            );
        }
    },
    watch: {
        usersSelected: function () {
            this.clearErrors(this.name);
            this.$emit("update:field", this.usersSelected);
        },
        usersPreSelected: {
            immediate: true,
            handler() {
                if (Array.isArray(this.usersPreSelected) && this.usersPreSelected.length > 0) {
                    this.usersSelected = this.usersPreSelected.map(user => ({
                        id: user.data.id,
                        name: `${user.data.first_name} ${user.data.last_name}`
                    }));
                    this.users = [...this.usersSelected];
                }
            }
        }
    }
}
</script>

<style>

</style>
